var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrismaAccessBrowser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-8 -8 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 11.6093 22.7292 11.2235 22.6885 10.8436C22.208 11.3838 21.7437 11.8852 21.2917 12.3517L19.2747 14.2745C16.3238 16.8399 13.6605 18.0131 9.90255 19.1322C9.64926 19.2077 9.4988 19.47 9.57131 19.7241C9.76012 20.8158 10.0559 21.7955 10.6564 22.6669C11.0966 22.7217 11.545 22.75 12 22.75ZM6.96447 21.5001C7.1105 21.5777 7.27515 21.4451 7.23574 21.2845C6.97453 20.2201 6.7365 19.2322 6.5373 18.2817L6.31578 17.3019L6.34286 17.2946C5.74151 14.0093 5.69409 11.0189 6.8923 6.58936C6.96375 6.32522 6.80842 6.05119 6.54266 5.98607C5.63811 5.58475 4.65844 5.3801 3.52949 5.3801C2.1013 7.20496 1.25 9.50307 1.25 12C1.25 16.1176 3.56501 19.6945 6.96447 21.5001ZM6.17502 2.96341C7.85345 1.87927 9.85324 1.25 12 1.25C16.3576 1.25 20.1097 3.8428 21.7976 7.56983C21.2917 8.67163 20.4256 9.61433 19.2762 10.2423C15.5353 6.47772 12.5852 4.58221 6.17502 2.96341ZM9.51056 16.3964C9.2198 16.485 8.92015 16.287 8.89515 15.9841C8.70489 13.6782 8.86605 10.9291 9.62738 7.55005C9.69287 7.25934 10.004 7.09763 10.2774 7.21622C12.6314 8.23738 14.6561 9.67397 16.8938 11.8219C17.097 12.0169 17.0894 12.3446 16.8763 12.5288C14.5516 14.5381 12.6646 15.4351 9.51056 16.3964Z",
    fill: "url(#paint0_linear_22119_136747)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22119_136747",
    x1: 5.03928,
    y1: 2.70824,
    x2: 18.5157,
    y2: 21.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576016,
    stopColor: "#2986F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991945,
    stopColor: "#02BEE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrismaAccessBrowser);
export default __webpack_public_path__ + "static/media/prismaAccessBrowser.647a6c414ab854447c744ce2a0ec5314.svg";
export { ForwardRef as ReactComponent };